'use client'

import { useLayoutEffect, useState } from 'react'

export default function Layout({ children }: { children: React.ReactNode }) {
  const [ready, setReady] = useState(false)

  useLayoutEffect(() => {
    const root = localStorage.getItem('persist:cloudpos-root')
    const session = localStorage.getItem('persist:appSession')

    if (root || session) {
      localStorage.removeItem('persist:cloudpos-root')
      localStorage.removeItem('persist:appSession')
      // Force hard navigation to reinitialize store
      window.location.reload()
      return
    }
    setReady(true)
  }, [])

  if (!ready) return null

  return <>{children}</>
}
